export function getLocaleUrl(locale: string, to: string) {
  return locale === 'en' ? to : `/${locale + to}`;
}
